import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye-gray--sprite",
  "use": "eye-gray--sprite-usage",
  "viewBox": "0 0 22 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 15\" id=\"eye-gray--sprite\"><defs><style>#eye-gray--sprite .cls-1{fill:#c6c6c6;}</style></defs><title>eye-gray</title><path class=\"cls-1\" d=\"M12,9a3,3,0,1,0,3,3,3,3,0,0,0-3-3m0,8a5,5,0,1,1,5-5,5,5,0,0,1-5,5M12,4.5A11.83,11.83,0,0,0,1,12a11.82,11.82,0,0,0,22,0A11.83,11.83,0,0,0,12,4.5Z\" transform=\"translate(-1 -4.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol